<template>
  <el-container class="container">
    <el-header class="header-style">
      <el-divider content-position="left">服务进度</el-divider>
      <el-row>
        <el-col :span="8">
          <el-input
            v-model="searchArr.refund_order"
            filterable
            remote
            reserve-keyword
            placeholder="关键词:订单号、客户或法人姓名、手机号、公司名称"
            size="mini"
            clearable
            @change="handleSearchCfcategory"
          >
          </el-input>
        </el-col>
        <!-- <el-col :span="12">
          <el-tooltip
            :content="
              '核名：' +
              counts.verifierCount +
              '，网报：' +
              counts.declareCount +
              '，网签：' +
              counts.signatoryCount +
              '，领取执照：' +
              counts.licenseCount +
              '，刻章：' +
              counts.chapterCount +
              '，材料交接：' +
              counts.materialCount
            "
          >
            <div class="count-style">
              <span class="count">核名：{{ counts.verifierCount }}</span>
              <span class="count">网报：{{ counts.declareCount }}</span>
              <span class="count">网签：{{ counts.signatoryCount }}</span>
              <span class="count">领取执照：{{ counts.licenseCount }}</span>
              <span class="count">刻章：{{ counts.chapterCount }}</span>
              <span class="count">材料交接：{{ counts.materialCount }}</span>
            </div>
          </el-tooltip>
        </el-col>
        <el-col :span="8" :offset="4">
          <el-tooltip
            :content="
              '总数：' +
              counts.total +
              '，服务中：' +
              counts.in_service +
              '，已完成：' +
              counts.service_complete
            "
          >
            <div class="count-style">
              <span class="count">总数：{{ counts.total }}</span>
              <span class="count">服务中：{{ counts.in_service }}</span>
              <span class="count">已完成：{{ counts.service_complete }}</span>
            </div>
          </el-tooltip>
        </el-col> -->
      </el-row>
      <!-- <el-row :gutter="20" class="mb-10">

        <el-col :span="8" :offset="6">
          <el-input
            v-model="searchArr.refund_order"
            filterable
            remote
            reserve-keyword
            placeholder="关键词:订单号、客户或法人姓名、手机号、公司名称"
            size="mini"
            clearable
            @change="handleSearchCfcategory"
          >
          </el-input>
        </el-col>
      </el-row> -->

      <el-collapse v-model="activeOpen">
        <el-collapse-item title="高级筛选" name="1">
          <div style="padding: 10px">
            <el-row class="mb-20 search-row" :gutter="24">
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>服务状态</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-select
                  v-model="searchArr.service_status"
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option :value="3" label="服务中"></el-option>
                  <el-option :value="4" label="服务完成"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>沟通顾问</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.consultant"
                  placeholder="请选择沟通顾问"
                  :options="personnel"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>办理节点</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-select
                  v-model="searchArr.handNode"
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option :value="1" label="核名"></el-option>
                  <el-option :value="2" label="网报"></el-option>
                  <el-option :value="3" label="网签"></el-option>
                  <el-option :value="4" label="领取执照"></el-option>
                  <el-option :value="5" label="刻章"></el-option>
                  <el-option :value="6" label="材料交接"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="mb-20 search-row" :gutter="24">
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>行业特点</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-select
                  v-model="searchArr.feature"
                  filterable
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option
                    v-for="item in features"
                    :key="item.industry_id"
                    :label="item.industry_name"
                    :value="item.industry_id"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>服务人员</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-cascader
                  style="width: 100%"
                  v-model="searchArr.operator"
                  placeholder="请选择服务人员"
                  :options="personnel"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-col>
              <el-col :xs="24" :sm="4" :md="3" :lg="2"><span>注册类型</span></el-col>
              <el-col :xs="24" :sm="8" :md="5" :lg="6">
                <el-select
                  v-model="searchArr.actual_reg_type"
                  placeholder="请选择"
                  size="mini"
                  clearable
                >
                  <el-option
                    v-for="item in regTypes"
                    :key="item.reg_type_id"
                    :label="item.reg_type_name"
                    :value="item.reg_type_id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="text-align: center">
              <el-button type="primary" size="mini" @click="handleASearSub"
                >查询</el-button
              >
              <el-button type="danger" size="mini" @click="handleASearClear"
                >清除</el-button
              >
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-header>

    <el-main class="main-style">
      <el-table
        height="calc(100vh - 306px)"
        :data="pageData"
        size="medium"
        style="width: 100%"
        v-cloak
        border
      >
        <el-table-column fixed label="订单编号" width="190" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link
              class="ellipsis-link"
              type="primary"
              @click="handleLogOpen(scope.$index, scope.row.id)"
              >{{ scope.row.order_num }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column fixed label="服务状态" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.service_status === '服务中'">
              <span class="dot" style="background-color: #88d023"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
            <div v-else>
              <span class="dot" style="background-color: #ff8839"></span>
              <el-link disabled>{{ scope.row.service_status }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="顾问">
          <template slot-scope="scope">
            <span v-if="scope.row.advisor">{{ scope.row.advisor.username }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in col"
          :label="item.label"
          :key="index"
          :width="item.width ? item.width : 120"
          :show-overflow-tooltip="item.tooltip"
        >
          <template slot-scope="scope">
            <!-- <el-tooltip
              v-if="item.prop === 'customer_phone'"
              :content="scope.row.customer_phone"
              placement="top"
            >
              <span class="count-style">{{
                scope.row.customer_phone
                  ? scope.row.customer_phone.substring(0, 5) + "..."
                  : ""
              }}</span>
            </el-tooltip> -->
            <phone-com
              v-if="item.prop === 'customer_phone'"
              :comPhone="scope.row.customer_phone"
              :vagaryPhone="scope.row.vagary_phone_custome"
              style="display: inline-block"
            />
            <!-- <el-tooltip
              v-else-if="item.prop === 'corporate_phone'"
              :content="scope.row.corporate_phone"
              placement="top"
            >
              <span class="count-style"
                >{{
                  scope.row.corporate_phone
                    ? scope.row.corporate_phone.substring(0, 5) + "..."
                    : ""
                }}
              </span>
            </el-tooltip> -->
            <phone-com
              v-else-if="item.prop === 'corporate_phone'"
              :comPhone="scope.row.corporate_phone"
              :vagaryPhone="scope.row.vagary_phone_corporate"
              style="display: inline-block"
            />
            <el-tooltip
              v-else-if="item.prop === 'company'"
              :content="scope.row.company"
              placement="top"
            >
              <span class="count-style"
                >{{ scope.row.company ? scope.row.company : "" }}
              </span>
            </el-tooltip>
            <div v-else>
              <span class="count-style">{{ scope.row[item.prop] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <!-- <el-tooltip class="item" effect="dark" content="办理信息" placement="top">
            <el-button :type="scope.row.service_status === '服务完成' ? 'success' : 'info'"
              :icon="scope.row.service_status === '服务完成' ? 'el-icon-check' : 'el-icon-edit-outline'" size="mini" circle
              @click="handleConduct(scope.$index, scope.row)" :disabled="scope.row.order_status === '已退款'"></el-button>
          </el-tooltip> -->
            <el-tooltip
              class="item"
              effect="dark"
              content="企业微信群聊天记录"
              placement="top"
            >
              <el-button
                type="warning"
                :disabled="scope.row.wx_work_chat_com ? false : true"
                @click="
                  handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
                "
                size="mini"
                icon="el-icon-s-comment"
                circle
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        layout="sizes, total, prev, pager, next, jumper"
        :total="pageOption.total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        background
      >
      </el-pagination>
    </el-footer>

    <el-drawer
      title="办理信息"
      :visible.sync="conductDrawer"
      direction="rtl"
      :before-close="handleConductClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>网报</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">人员</el-col>
                <el-col :span="7">
                  <el-select
                    v-model="conductForm.declarer"
                    filterable
                    placeholder="请选择"
                    clearable
                    :size="inputSize"
                    @change="
                      handelPeople('declarer', 'declarer_name', '网报人员', 'conductForm')
                    "
                  >
                    <el-option
                      v-for="option in personnel"
                      :key="option.id"
                      :label="option.username"
                      :value="option.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">时间</el-col>
                <el-col :span="7">
                  <el-date-picker
                    v-model="conductForm.declare_at"
                    type="date"
                    placeholder="选择日期"
                    :size="inputSize"
                    value-format="yyyy-MM-dd"
                    @change="handelPickerChange('declare_at', '网报时间')"
                  ></el-date-picker>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">区域</el-col>
                <el-col :span="7">
                  <el-select
                    v-model="conductForm.area"
                    placeholder="请选择"
                    clearable
                    size="mini"
                    @change="handleAreaSub('area', '区域', 'conductForm')"
                  >
                    <el-option
                      v-for="item in areas"
                      :label="item.areaName"
                      :value="item.id"
                      :key="item.id"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">园区</el-col>
                <el-col :span="7">
                  <el-select
                    v-model="conductForm.park"
                    placeholder="请选择"
                    clearable
                    size="mini"
                    @change="handleParkChange('park', '园区', 'conductForm')"
                  >
                    <el-option
                      v-for="item in changeParks"
                      :label="item.areaName"
                      :value="item.id"
                      :key="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix">
              <span>核名</span>
            </div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">核名名称</el-col>
                <el-col :span="7">
                  <el-input
                    v-model="conductForm.verification_company_name"
                    :size="inputSize"
                    clearable
                    @blur.native.capture="
                      handleConductChange('verification_company_name', '核名名称')
                    "
                    @clear="handleConductChange('verification_company_name', '核名名称')"
                  ></el-input>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">人员</el-col>
                <el-col :span="7">
                  <el-select
                    v-model="conductForm.verifier"
                    filterable
                    placeholder="请选择"
                    clearable
                    :size="inputSize"
                    @change="
                      handelPeople('verifier', 'verifier_name', '核名人员', 'conductForm')
                    "
                  >
                    <el-option
                      v-for="option in personnel"
                      :key="option.id"
                      :label="option.username"
                      :value="option.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="m-label">时间</el-col>
                <el-col :span="7">
                  <el-date-picker
                    v-model="conductForm.verifier_at"
                    type="date"
                    placeholder="选择日期"
                    :size="inputSize"
                    value-format="yyyy-MM-dd"
                    @change="handelPickerChange('verifier_at', '核名时间')"
                  ></el-date-picker>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">核名状态</el-col>
                <el-col :span="7">
                  <el-tooltip :content="conductForm.verification_state" placement="top">
                    <el-switch
                      v-model="conductForm.verification_state"
                      active-color="#5789F4"
                      inactive-color="#dcdfe6"
                      active-value="通过"
                      inactive-value="未通过"
                      @change="handelSaveChange('verification_state', '核名状态')"
                    >
                    </el-switch>
                  </el-tooltip>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix"><span>网签</span></div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">人员</el-col>
                <el-col :span="7">
                  <el-select
                    v-model="conductForm.signatory"
                    filterable
                    placeholder="请选择"
                    clearable
                    :size="inputSize"
                    @change="
                      handelPeople(
                        'signatory',
                        'signatory_name',
                        '网签人员',
                        'conductForm'
                      )
                    "
                  >
                    <el-option
                      v-for="option in personnel"
                      :key="option.id"
                      :label="option.username"
                      :value="option.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">时间</el-col>
                <el-col :span="7">
                  <el-date-picker
                    v-model="conductForm.signatory_at"
                    type="date"
                    placeholder="选择日期"
                    :size="inputSize"
                    value-format="yyyy-MM-dd"
                    @change="handelPickerChange('signatory_at', '网签时间')"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix"><span>执照</span></div>
            <el-row>
              <el-col :span="4" class="m-label">人员</el-col>
              <el-col :span="7">
                <el-select
                  v-model="conductForm.licensee"
                  filterable
                  placeholder="请选择"
                  clearable
                  :size="inputSize"
                  @change="
                    handelPeople(
                      'licensee',
                      'licensee_name',
                      '执照领取人员',
                      'conductForm'
                    )
                  "
                >
                  <el-option
                    v-for="option in personnel"
                    :key="option.id"
                    :label="option.username"
                    :value="option.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="2" class="m-label">时间</el-col>
              <el-col :span="7">
                <el-date-picker
                  v-model="conductForm.license_at"
                  type="date"
                  placeholder="选择日期"
                  :size="inputSize"
                  value-format="yyyy-MM-dd"
                  @change="handelPickerChange('license_at', '执照领取时间')"
                ></el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">公司名称</el-col>
              <el-col :span="7">
                <el-select
                  v-model="conductForm.company_id"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="输入公司"
                  size="mini"
                  clearable
                  :remote-method="remoteMethod"
                  :loading="loading"
                  @change="handleCompanyChange()"
                >
                  <el-option
                    v-for="company in companies"
                    :key="company.company_name + company.id"
                    :label="company.company_name"
                    :value="company.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-card shadow="always">
                <div slot="header" class="clearfix"><span>执照扫描件</span></div>
                <el-row>
                  <el-upload
                    :action="actionHost + '/api/upload/tyc/annex'"
                    :headers="uploadHeader"
                    :data="{ id: conductForm.id, type: 2 }"
                    :on-success="handleConductAnnexSuccess"
                    :on-preview="handleConductPreview"
                    :on-remove="handleConductRemove"
                    :file-list="conductFileList"
                  >
                    <el-link type="primary">上传</el-link>
                  </el-upload>
                </el-row>
              </el-card>
            </el-row>
          </el-card>
        </el-row>
        <el-row v-show="conductForm.chapter === '是'">
          <el-card shadow="always">
            <div slot="header" class="clearfix"><span>刻章</span></div>
            <div>
              <el-row>
                <el-col :span="4" class="m-label">人员</el-col>
                <el-col :span="7">
                  <el-select
                    v-model="conductForm.chapter_pr"
                    filterable
                    placeholder="请选择"
                    clearable
                    :size="inputSize"
                    @change="
                      handelPeople(
                        'chapter_pr',
                        'chapter_name',
                        '刻章人员',
                        'conductForm'
                      )
                    "
                  >
                    <el-option
                      v-for="option in personnel"
                      :key="option.id"
                      :label="option.username"
                      :value="option.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="2" class="m-label">时间</el-col>
                <el-col :span="7">
                  <el-date-picker
                    v-model="conductForm.chapter_at"
                    type="date"
                    placeholder="选择日期"
                    :size="inputSize"
                    value-format="yyyy-MM-dd"
                    @change="handelPickerChange('chapter_at', '刻章时间')"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-row>
        <el-row>
          <el-card shadow="always">
            <div slot="header" class="clearfix"><span>材料交接</span></div>
            <el-row>
              <el-col :span="4" class="m-label">人员</el-col>
              <el-col :span="7">
                <el-select
                  v-model="conductForm.material"
                  filterable
                  placeholder="请选择"
                  clearable
                  :size="inputSize"
                  @change="
                    handelPeople(
                      'material',
                      'material_name',
                      '材料交接人员',
                      'conductForm'
                    )
                  "
                >
                  <el-option
                    v-for="option in personnel"
                    :key="option.id"
                    :label="option.username"
                    :value="option.id"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="2" class="m-label">时间</el-col>
              <el-col :span="7">
                <el-date-picker
                  v-model="conductForm.material_at"
                  type="date"
                  placeholder="选择日期"
                  :size="inputSize"
                  value-format="yyyy-MM-dd"
                  @change="handelPickerChange('material_at', '材料交接时间')"
                ></el-date-picker>
              </el-col>
            </el-row>
            <el-row>
              <el-card shadow="always">
                <div slot="header" class="clearfix"><span>附件</span></div>
                <el-row>
                  <el-upload
                    :action="actionHost + '/api/upload/tyc/annex'"
                    :headers="uploadHeader"
                    :data="{ id: conductForm.id, type: 3 }"
                    :on-success="handleMaterialSuccess"
                    :on-preview="handleMaterialPreview"
                    :on-remove="handleMaterialRemove"
                    :file-list="materialFlieList"
                  >
                    <el-link type="primary">上传</el-link>
                  </el-upload>
                </el-row>
              </el-card>
            </el-row>
          </el-card>
        </el-row>
        <el-row style="text-align: right">
          <span>办理进度</span>
          <el-button
            v-if="conductForm.service_status === '服务完成'"
            type="info"
            size="mini"
            disabled
            >已完成</el-button
          >
          <el-button v-else type="primary" size="mini" @click="handleConductComplete"
            >完成</el-button
          >
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      :title="'订单信息： ' + orderContent.order_num"
      :visible.sync="logDrawer"
      direction="rtl"
      custom-class="AIdrawer"
      :before-close="handleLogBeforeClose"
      size="50%"
    >
      <div class="drawer-title" slot="title">订单信息： {{ orderContent.order_num }}</div>
      <div class="m-tabs-content">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="info">
            <el-row :gutter="20">
              <el-col :span="4">订单号:</el-col>
              <el-col :span="20">
                <span style="cursor: pointer" @click="copyUrl(orderContent.order_num)">{{
                  orderContent.order_num
                }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4">来源:</el-col>
              <el-col :span="20">
                <span>{{ orderSources }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4">金额:</el-col>
              <el-col :span="8">{{ orderContent.total_amount }}</el-col>
              <el-col :span="4">园区:</el-col>
              <el-col :span="8">{{ orderContent.order_park }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4">订单类型:</el-col>
              <el-col :span="8">{{ orderContent.order_reg_type }}</el-col>
              <el-col :span="4">派单时间:</el-col>
              <el-col :span="8">{{ orderContent.assign_at }}</el-col>
            </el-row>
            <el-row v-if="orderContent.order_reg_type === '单品'" :gutter="20">
              <el-col :span="4">单品:</el-col>
              <el-col :span="20">
                <span v-for="item in orderItems" :key="item.item_id"
                  >{{ item.item_name }}
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4">服务状态:</el-col>
              <el-col :span="8">{{ orderContent.service_status }}</el-col>
              <el-col :span="4">顾问:</el-col>
              <el-col :span="8">{{ orderContent.advisor }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="4">订单转化人:</el-col>
              <el-col :span="8">{{ orderContent.trans }}</el-col>
              <el-col :span="4">套餐:</el-col>
              <el-col :span="8">{{ orderContent.proxy_meal }}</el-col>
            </el-row>
            <el-divider content-position="left">服务反馈</el-divider>
            <el-row>
              <el-timeline>
                <el-timeline-item
                  v-for="schedule in schedules"
                  :key="schedule.id"
                  :timestamp="schedule.created_at"
                  placement="top"
                >
                  <el-card>
                    <h5>
                      {{ schedule.executor }} 通过 {{ schedule.contact_type }} 进行联系
                      <span v-if="schedule.contact_duration">
                        沟通了 {{ schedule.contact_duration }} 秒</span
                      >
                    </h5>
                    <p>{{ schedule.reflect_content }}</p>
                    <ul class="el-upload-list el-upload-list--picture">
                      <li
                        class="el-upload-list__item is-success"
                        v-for="image in schedule.images"
                        :key="image.id"
                      >
                        <img class="el-upload-list__item-thumbnail" :src="image.url" />
                        <a
                          class="el-upload-list__item-name"
                          @click="handleReflectPreview(image)"
                          >{{ image.name }}</a
                        >
                      </li>
                    </ul>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-row>
            <div v-if="orderContent.isRegistration">
              <el-divider content-position="left"
                >{{ orderContent.company }}服务进度</el-divider
              >
              <el-timeline>
                <el-timeline-item
                  :timestamp="orderContent.verifier_at"
                  placement="top"
                  :color="orderContent.verifier_at ? '#67c23a' : ''"
                >
                  <el-card>核名 {{ orderContent.verifier_name }}</el-card>
                </el-timeline-item>
                <el-timeline-item
                  :timestamp="orderContent.declare_at"
                  placement="top"
                  :color="orderContent.declare_at ? '#67c23a' : ''"
                >
                  <el-card>网报 {{ orderContent.declarer_name }}</el-card>
                </el-timeline-item>
                <el-timeline-item
                  :timestamp="orderContent.signatory_at"
                  placement="top"
                  :color="orderContent.signatory_at ? '#67c23a' : ''"
                >
                  <el-card>网签 {{ orderContent.signatory_name }}</el-card>
                </el-timeline-item>
                <el-timeline-item
                  :timestamp="orderContent.license_at"
                  placement="top"
                  :color="orderContent.license_at ? '#67c23a' : ''"
                >
                  <el-card>领执照 {{ orderContent.licensee_name }}</el-card>
                </el-timeline-item>
                <el-timeline-item
                  v-if="orderContent.chapter === '是'"
                  :timestamp="orderContent.chapter_at"
                  placement="top"
                  :color="orderContent.chapter_at ? '#67c23a' : ''"
                >
                  <el-card>刻章 {{ orderContent.chapter_name }}</el-card>
                </el-timeline-item>
                <el-timeline-item
                  :timestamp="orderContent.material_at"
                  placement="top"
                  :color="orderContent.material_at ? '#67c23a' : ''"
                >
                  <el-card>材料交接 {{ orderContent.material_name }}</el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-tab-pane>
          <el-tab-pane label="反馈记录" name="reflect">
            <el-row>
              <el-col :span="6" class="m-label">联系方式</el-col>
              <el-col :span="10">
                <el-select
                  v-model="reflectForm.contact_type"
                  filterable
                  placeholder="请选择"
                  clearable
                  :size="inputSize"
                >
                  <el-option :value="1" label="电话联系"></el-option>
                  <el-option :value="8" label="服务进度"></el-option>
                  <el-option :value="2" label="手机短信"></el-option>
                  <el-option :value="3" label="发送快递"></el-option>
                  <el-option :value="4" label="微信交流"></el-option>
                  <el-option :value="5" label="见面拜谈"></el-option>
                  <el-option :value="6" label="公司洽谈"></el-option>
                  <el-option :value="7" label="优开平台"></el-option>
                  <el-option :value="9" label="QQ沟通"></el-option>
                  <el-option :value="10" label="钉钉沟通"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row v-if="reflectForm.contact_type === 1">
              <el-col :span="6" class="m-label">通话时长</el-col>
              <el-col :span="10">
                <el-input
                  placeholder="请输入内容"
                  v-model="reflectForm.contact_duration"
                  :size="inputSize"
                >
                  <template slot="append">秒</template>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="reflectForm.content"
              ></el-input>
            </el-row>
            <el-row class="mt-10 tr">
              <el-button type="primary" size="mini" @click="handleReflect"
                >添加</el-button
              >
            </el-row>
            <el-divider content-position="left">反馈历史</el-divider>
            <el-row>
              <el-timeline>
                <el-timeline-item
                  v-for="reflect in reflects"
                  :key="reflect.id"
                  :timestamp="reflect.created_at"
                  placement="top"
                >
                  <el-card>
                    <h5>
                      {{ reflect.executor }} 通过 {{ reflect.contact_type }} 进行联系
                      <span v-if="reflect.contact_duration">
                        沟通了 {{ reflect.contact_duration }} 秒</span
                      >
                    </h5>
                    <p>{{ reflect.reflect_content }}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="操作记录" name="logs">
            <el-row>
              <el-timeline>
                <el-timeline-item
                  v-for="log in logs"
                  :key="log.id"
                  :timestamp="log.created_at"
                  placement="top"
                >
                  <el-card>
                    <p>{{ log.log_content }}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-row>
          </el-tab-pane>
          <el-tab-pane name="relationOrders">
            <el-badge slot="label" :value="orderStatusCount" class="setBadge"
              >相关订单</el-badge
            >
            <el-table :data="relationOrders" style="width: 100%">
              <el-table-column prop="order_num" label="订单号"></el-table-column>
              <el-table-column
                prop="order_reg.order_reg_name"
                label="订单类型"
              ></el-table-column>
              <el-table-column
                :prop="'consultant' ? 'advisor.username' : 'consultant'"
                label="顾问"
              ></el-table-column>
              <el-table-column prop="service_status" label="服务状态"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
    <el-drawer
      title="企业微信聊天记录"
      :visible.sync="wxChatDrawer"
      direction="rtl"
      :before-close="handleWxChatBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat
            :chatId="wxWorkChatId"
            :chatName="wxWorkchatCompany"
          ></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import WxWorkChat from "common/WxWorkChat";
import PhoneCom from "common/PhoneCom";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "Speed",
  components: { WxWorkChat, PhoneCom },
  data() {
    return {
      activeOpen: "",
      wxChatDrawer: false,
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      orderSources: "",
      relationOrders: [],
      relationCount: 0,
      fulfill: 0,
      orderItems: [],
      schedules: [],
      orderContent: {
        order_num: "",
        total_amount: null,
        order_reg_type: "",
        assign_at: "",
        advisor: "",
        trans: "",
        proxy_meal: "",
        order_status: "",
        service_status: "",
        verifier_at: null,
        declare_at: null,
        signatory_at: null,
        license_at: null,
        chapter: "否",
        chapter_at: null,
        material_at: null,
        verifier_name: "",
        declarer_name: "",
        signatory_name: "",
        licensee_name: "",
        chapter_name: "",
        material_name: "",
        order_park: "",
        isRegistration: 0,
      },
      meals: [],
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      counts: {
        total: 0,
        in_service: 0,
        service_complete: 0,
        verifierCount: 0,
        declareCount: 0,
        signatoryCount: 0,
        licenseCount: 0,
        chapterCount: 0,
        materialCount: 0,
      },
      orders: [],
      personnel: [],
      features: [],
      orderRegs: [],
      regTypes: [],
      col: [
        {
          label: "服务人员",
          prop: "operator_name",
        },
        {
          label: "客户姓名",
          prop: "customer_name",
        },
        {
          label: "客户手机",
          prop: "customer_phone",
          width: 170,
        },
        {
          label: "法人姓名",
          prop: "corporate_name",
        },
        {
          label: "法人手机",
          prop: "corporate_phone",
          width: 170,
        },
        {
          label: "核名时间",
          prop: "verifier_at",
        },
        {
          label: "核名人",
          prop: "verifier_name",
        },
        {
          label: "公司名称",
          prop: "company",
        },
        {
          label: "网报时间",
          prop: "declare_at",
        },
        {
          label: "网报人",
          prop: "declarer_name",
        },
        {
          label: "网签时间",
          prop: "signatory_at",
        },
        {
          label: "网签人",
          prop: "signatory_name",
        },
        {
          label: "执照领取时间",
          prop: "license_at",
        },
        {
          label: "执照领取人",
          prop: "licensee_name",
        },
        {
          label: "是否刻章",
          prop: "chapter",
        },
        {
          label: "刻章时间",
          prop: "chapter_at",
        },
        {
          label: "刻章人",
          prop: "chapter_name",
        },
        {
          label: "材料交接时间",
          prop: "material_at",
        },
        {
          label: "材料交接人",
          prop: "material_name",
        },
      ],
      search: "",
      searchArr: {
        service_status: "",
        consultant: null,
        handNode: null,
        feature: null,
        actual_reg_type: null,
        operator: null,
        refund_order: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1,
        // searchCurrentPage: 1,
        pageSize: 30,
      },
      conductForm: {
        index: null,
        id: 0,
        verifier: "",
        verifier_at: "",
        verification_company_name: null,
        verification_state: "未通过",
        company: null,
        company_id: null,
        declarer: "",
        declare_at: "",
        signatory: "",
        signatory_at: "",
        licensee: "",
        license_at: "",
        chapter: "否",
        chapter_pr: "",
        chapter_at: "",
        order_status: "",
        service_status: "",
        material: null,
        material_at: "",
        area: null,
        park: null,
      },
      conductDrawer: false,
      logDrawer: false,
      conductFileList: [],
      materialFlieList: [],
      inputSize: "small",
      logs: [],
      reflects: [],
      reflectForm: {
        index: null,
        id: 0,
        content: "",
        contact_type: null,
        contact_duration: 0,
      },
      activeName: "info",
      areas: [],
      parks: [],
      changeParks: [],
      companies: [],
      loading: false,
      pageData: [],
    };
  },
  watch: {},
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    orderStatusCount: {
      get: function () {
        return this.fulfill + "/" + this.relationCount;
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickCollapseOutSide);
  },
  methods: {
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector(".el-collapse");
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = "";
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handelGetOrders() {
      this.$axios
        .get(
          "/api/admin/tyc_order/speeds?page=" +
            this.pageOption.currentPage +
            "&pagesize=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData = data.data.orders.data;
            this.pageOption.total = data.data.orders.total;
            // 参数数据
            this.counts.total = data.data.counts.total;
            this.counts.in_service = data.data.counts.in_service;
            this.counts.service_complete = data.data.counts.service_complete;
            this.counts.verifierCount = data.data.counts.verifierCount;
            this.counts.declareCount = data.data.counts.declareCount;
            this.counts.signatoryCount = data.data.counts.signatoryCount;
            this.counts.licenseCount = data.data.counts.licenseCount;
            this.counts.chapterCount = data.data.counts.chapterCount;
            this.counts.materialCount = data.data.counts.materialCount;
            this.personnel = data.data.personnel;
            this.features = data.data.features;
            this.meals = data.data.meals;
            this.orderRegs = data.data.orderRegs;
            this.regTypes = data.data.regTypes;
            this.areas = data.data.areas;
            this.parks = data.data.parks;
          }
        });
    },
    handleASearSub() {
      this.pageOption.currentPage = 1;
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleASearClear() {
      this.searchArr.service_status = "";
      this.searchArr.consultant = null;
      this.searchArr.handNode = null;
      this.searchArr.feature = null;
      this.searchArr.actual_reg_type = null;
      this.searchArr.operator = null;
      this.pageOption.currentPage = 1;
      this.activeOpen = "";
      this.handelGetOrders();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders();
    },
    handleSearchCfcategory(query) {
      this.pageOption.currentPage = 1;
      this.searchArr.refund_order = query;
      setTimeout(() => {
        this.handelGetOrders();
      });
    },
    handleLogOpen(index, id) {
      this.$axios.get("/api/admin/tyc_orders/log/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.logs = data.data.logs;
          this.reflects = data.data.reflects;
          this.setSchedule(data.data.reflects);
          this.reflectForm.index = index;
          this.reflectForm.id = id;
          this.setOrderContent(index);
          this.orderItems = data.data.items;
          this.orderSources = this.pageData[index].source
            ? this.pageData[index].source.source_name
            : "";
          this.relationOrders = data.data.relationOrders;
          this.relationCount = data.data.relationOrders.length;
          this.countFulfill(data.data.relationOrders);
          this.logDrawer = true;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    countFulfill(relationOrders) {
      for (var i = 0; i < relationOrders.length; i++) {
        if (relationOrders[i].service_status === "服务完成") {
          this.fulfill++;
        }
      }
    },
    setSchedule(reflects) {
      for (var i = 0; i < reflects.length; i++) {
        if (reflects[i].contact_type === "服务进度") {
          this.schedules.push(reflects[i]);
        }
      }
    },
    setOrderContent(index) {
      this.orderContent.order_num = this.pageData[index].order_num;
      this.orderContent.total_amount = this.pageData[index].total_amount;
      this.orderContent.order_reg_type = this.getOrderRegTypeName(
        this.pageData[index].order_reg_type
      );
      this.orderContent.assign_at = this.pageData[index].assign_at;
      this.orderContent.advisor = this.pageData[index].advisor
        ? this.pageData[index].advisor.username
        : "";
      this.orderContent.trans = this.pageData[index].trans
        ? this.pageData[index].trans.username
        : "自助下单";
      this.orderContent.proxy_meal = this.pageData[index].proxy_meal
        ? this.getMealName(this.pageData[index].proxy_meal)
        : "无";
      this.orderContent.order_status = this.pageData[index].order_status;
      this.orderContent.service_status = this.pageData[index].service_status;
      this.orderContent.verifier_at = this.pageData[index].verifier_at;
      this.orderContent.declare_at = this.pageData[index].declare_at;
      this.orderContent.signatory_at = this.pageData[index].signatory_at;
      this.orderContent.license_at = this.pageData[index].license_at;
      this.orderContent.chapter = this.pageData[index].chapter;
      this.orderContent.chapter_at = this.pageData[index].chapter_at;
      this.orderContent.material_at = this.pageData[index].material_at;
      this.orderContent.verifier_name = this.pageData[index].verifier_name;
      this.orderContent.declarer_name = this.pageData[index].declarer_name;
      this.orderContent.signatory_name = this.pageData[index].signatory_name;
      this.orderContent.licensee_name = this.pageData[index].licensee_name;
      this.orderContent.chapter_name = this.pageData[index].chapter_names;
      this.orderContent.material_name = this.pageData[index].material_name;
      this.orderContent.order_park = this.pageData[index].order_park;
      this.orderContent.isRegistration = this.pageData[index].isRegistration;
    },
    getMealName(id) {
      let name = "";
      for (var i = 0; i < this.meals.length; i++) {
        if (this.meals[i].combo_id === id) {
          name = this.meals[i].combo_name;
        }
      }

      return name;
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
},
    handleReflect() {
      if (!this.reflectForm.contact_type) {
        this.$message.error("请选择联系方式");
        return;
      }

      if (
        this.reflectForm.contact_type === 1 &&
        !/(^[1-9]\d*$)/.test(this.reflectForm.contact_duration)
      ) {
        this.$message.error("请填写通话时长，必须为正整数");
        return;
      }

      if (!this.reflectForm.content) {
        this.$message.error("内容不能为空");
        return;
      }

      this.$axios
        .post("/api/admin/tyc_order_reflect", {
          order_id: this.reflectForm.id,
          reflect_content: this.reflectForm.content,
          contact_type: this.reflectForm.contact_type,
          contact_duration: this.reflectForm.contact_duration,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.reflects.unshift(data.data);
            this.reflectForm.content = "";
            this.reflectForm.contact_type = null;
            this.reflectForm.contact_duration = 0;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleLogBeforeClose(done) {
      this.activeName = "info";
      this.reflectForm.index = null;
      this.reflectForm.id = 0;
      this.reflectForm.content = "";
      this.reflectForm.contact_type = null;
      this.reflectForm.contact_duration = 0;
      this.reflects = [];
      this.relationOrders = [];
      this.relationCount = 0;
      this.fulfill = 0;
      this.orderItems = [];
      this.schedules = [];
      this.orderSources = "";
      done();
    },
    handleConduct(index, row) {
      this.conductForm.index = index;
      this.conductForm.id = row.id;
      this.conductForm.verifier = row.verifier;
      this.conductForm.verifier_at = row.verifier_at;
      this.conductForm.verification_company_name = row.verification_company_name;
      this.conductForm.verification_state = row.verification_state;
      this.conductForm.company = row.company;
      this.conductForm.company_id = row.company_id;
      if (row.company_id && row.company)
        this.companies.push({ id: row.company_id, company_name: row.company });
      this.conductForm.declarer = row.declarer;
      this.conductForm.declare_at = row.declare_at;
      this.conductForm.signatory = row.signatory;
      this.conductForm.signatory_at = row.signatory_at;
      this.conductForm.licensee = row.licensee;
      this.conductForm.license_at = row.license_at;
      this.conductForm.material = row.material;
      this.conductForm.material_at = row.material_at;
      this.conductFileList = row.conduct_annexes;
      this.materialFlieList = row.material_annexes;
      this.conductForm.chapter = row.chapter;
      this.conductForm.chapter_pr = row.chapter_pr;
      this.conductForm.chapter_at = row.chapter_at;
      this.conductForm.order_status = row.order_status;
      this.conductForm.service_status = row.service_status;
      this.conductForm.area = row.area;
      this.handleAreaChange(row.area);
      this.conductForm.park = row.park;
      this.conductDrawer = true;
    },
    handleConductClose(done) {
      this.clearConductData();
      done();
    },
    clearConductData() {
      this.conductForm.index = null;
      this.conductForm.id = 0;
      this.conductForm.verifier = "";
      this.conductForm.verifier_at = "";
      this.conductForm.verification_company_name = null;
      this.conductForm.verification_state = "未通过";
      this.conductForm.company = null;
      this.conductForm.company_id = null;
      this.conductForm.declarer = "";
      this.conductForm.declare_at = "";
      this.conductForm.signatory = "";
      this.conductForm.signatory_at = "";
      this.conductForm.licensee = "";
      this.conductForm.license_at = "";
      this.conductForm.chapter = "否";
      this.conductForm.chapter_pr = "";
      this.conductForm.chapter_at = "";
      this.conductForm.material = null;
      this.conductForm.material_at = "";
      this.conductFileList = [];
      this.materialFlieList = [];
      this.conductForm.order_status = "";
      this.conductForm.service_status = "";
      this.conductForm.area = null;
      this.conductForm.park = null;
      this.companies = [];
    },
    handleConductChange(field, fieldName) {
      let index = this.conductForm.index;
      if (this.pageData[index][field] === this.conductForm[field]) return;
      this.$axios
        .put("/api/admin/tyc_orders/field/" + this.conductForm.id, {
          field: String(field),
          fieldName: fieldName,
          value: this.conductForm[field],
          old: this.pageData[index][field],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this.conductForm[field];
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelPeople(field, relatedField, fieldName, type) {
      let index = this[type].index;
      let name = this.getPeopleName(this[type][field]);
      let old = this.getPeopleName(this.pageData[index][field]);

      if (name === old) return;

      this.handelPeopleChange(field, relatedField, fieldName, type, index, name, old);
    },
    getPeopleName(val) {
      let obj = {};
      let name = "";
      obj = this.personnel.find((item) => {
        return item.id === val;
      });

      if (obj) name = obj.username;

      return name;
    },
    handelPeopleChange(field, relatedField, fieldName, type, index, name, old) {
      let params = {
        field: String(field),
        relatedField: relatedField,
        fieldName: fieldName,
        value: this[type][field],
        name: name,
        old: old,
      };

      this.$axios
        .put("/api/admin/tyc_orders/people/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this[type][field];
            this.pageData[index][relatedField] = name;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelPickerChange(field, fieldName) {
      this.handleConductChange(field, fieldName);
    },
    handleConductAnnexSuccess(res, file) {
      if (res.code === 0) {
        this.conductFileList.push({
          id: res.data.id,
          name: file.name,
          url: this.imgPath + res.data.store_result,
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    handleConductPreview(file) {
      var tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    handleConductRemove(file, fileList) {
      this.$axios.delete("/api/admin/tyc_annex/" + file.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let index = this.conductForm.index;
          this.conductFileList = fileList;
          this.pageData[index].conduct_annexes = fileList;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleMaterialSuccess(res, file) {
      if (res.code === 0) {
        this.materialFlieList.push({
          id: res.data.id,
          name: file.name,
          url: this.imgPath + res.data.store_result,
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    handleMaterialPreview(file) {
      var tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    handleMaterialRemove(file, fileList) {
      this.$axios.delete("/api/admin/tyc_annex/" + file.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let index = this.conductForm.index;
          this.materialFlieList = fileList;
          this.pageData[index].material_annexes = fileList;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleConductComplete() {
      let index = this.conductForm.index;
      if (!this.pageData[index].corporate_name) {
        this.$message.error("请选完善法人姓名");
        return;
      }

      if (!this.pageData[index].corporate_phone) {
        this.$message.error("请选完善法人手机号");
        return;
      }
      this.conductForm.service_status = "服务完成";
      this.handleConductChange("service_status", "办理进度");
    },
    getOrderRegTypeName(val) {
      let obj = {};
      let name = "";
      obj = this.orderRegs.find((item) => {
        return item.order_reg_id === val;
      });
      if (obj) name = obj.order_reg_name;
      return name;
    },
    copyUrl(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      // console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    handleAreaSub(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getAreaName(this[type][field]);
      let old = this.getAreaName(this.pageData[index][field]);

      // if (name === old) return

      this.handelSelSub(field, fieldName, type, index, name, old);
      this.handleAreaChange(this[type][field]);
    },
    handleAreaChange(val) {
      this.changeParks = [];
      this.conductForm.park = null;

      for (var i = 0; i < this.parks.length; i++) {
        if (this.parks[i].pid === val) {
          this.changeParks.push(this.parks[i]);
        }
      }
    },
    getAreaName(val) {
      let obj = {};
      let name = "";
      obj = this.areas.find((item) => {
        return item.id === val;
      });
      if (obj) name = obj.areaName;
      return name;
    },
    handleParkChange(field, fieldName, type) {
      let index = this[type].index;
      let name = this.getParkName(this[type][field]);
      let old = this.getParkName(this.pageData[index][field]);

      this.handelSelSub(field, fieldName, type, index, name, old);
    },
    getParkName(val) {
      let obj = {};
      let name = "";
      obj = this.parks.find((item) => {
        return item.id === val;
      });
      if (obj) name = obj.areaName;
      return name;
    },
    handelSelSub(field, fieldName, type, index, name, old) {
      let params = {
        field: String(field),
        fieldName: fieldName,
        value: this[type][field],
        nameStr: name,
        oldStr: old,
      };

      this.$axios
        .put("/api/admin/tyc_orders/sel/" + this[type].id, params)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this[type][field];
            if (field === "actual_reg_type") {
              this.pageData[index].reg_type = {
                reg_type_id: this[type][field],
                reg_type_name: name,
              };
            }

            if (field === "order_reg_type") {
              this.pageData[index].order_reg = {
                order_reg_id: this[type][field],
                order_reg_name: name,
              };
            }

            if (field === "sources") {
              this.pageData[index].sources = this[type][field];
              this.pageData[index].source = {
                source_id: this[type][field],
                source_name: name,
              };
            }
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleCompanyChange() {
      let oldName = this.conductForm.company;
      let newName = this.getCompanyName(this.conductForm.company_id);

      this.$axios
        .post("/api/admin/companyChange/" + this.conductForm.id, {
          oldName: oldName,
          newName: newName,
          changeId: this.conductForm.company_id,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.pageData[this.conductForm.index].company = newName;
            this.pageData[
              this.conductForm.index
            ].company_id = this.conductForm.company_id;
          }
        });
    },
    getCompanyName(id) {
      let newName = null;
      for (var i = 0; i < this.companies.length; i++) {
        if (this.companies[i].id === id) newName = this.companies[i].company_name;
      }

      return newName;
    },
    handelSaveChange(field, fieldName) {
      let index = this.conductForm.index;

      if (this.pageData[index][field] === this.conductForm[field]) return;
      this.$axios
        .put("/api/admin/tyc_orders/field/" + this.conductForm.id, {
          field: String(field),
          fieldName: fieldName,
          value: this.conductForm[field],
          old: this.pageData[index][field],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.pageData[index][field] = this.conductForm[field];
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
  },
  mounted() {
    this.handelGetOrders();
    document.addEventListener("click", this.handleClickCollapseOutSide);
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none;
.check-succ
  color: #67C23A
.setBadge >>> .el-badge__content.is-fixed
  top: .22rem
  right: .06rem
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.container >>> .el-drawer__header
  font-size: .36rem
  font-weight: 400
  color: #4D84FE
.container >>> .el-table__header th
  color: #333333
.container >>> .el-timeline-item__node--normal
  left: 0
  background-color: #ECF4FF
.el-select, .el-cascader
  width: 100%
.container
  marginLeft()
  max-height: 100vh
  .header-style
    z-index: 2;
    height: 125px !important
    padding: 0px !important
  .main-style
    z-index: 1;
    padding: 0px !important
    // overflow-y: auto
  .footer-style
    text-align: right
    .el-pagination
      padding-top: 25px
  .count-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.clearfix:before,
.clearfix:after
  display: table
  content: ""
.clearfix:after
  clear: both
.search-row .el-col
  margin-bottom: .2rem
.count
  padding-left: .2rem
  line-height: .56rem
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.tr
  text-align: right
.dot
  display: inline-block
  width: 0.1rem
  height: 0.1rem
  border-radius: 50%
  margin-right: 0.1rem
  top: 0
  left: -.2rem
  bottom: 0
  margin: auto
.mt-50
  margin-top: 1rem
.mt-10
  margin-top: .2rem
.mb-10
  margin-bottom: .2rem
.ellipsis-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.AIdrawer .drawer-title {
  background-color: #ecf5ff;
  padding: 10px;
  color: #409EFF;
}
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .tabs-title
    color: #5789F4
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
</style>



// WEBPACK FOOTER //
// src/pages/speed/Speed.vue